module.exports = __webpack_public_path__ + "img/tutor-banner-en.268a00ff.jpg";